const chars = '0123456789abcdef'
const charsForVariant = '89ab'
const randomCharacterFrom = ({ chars, length = 1 }) => Array(length).fill().map(() => chars[Math.floor(Math.random() * chars.length)]).join('')

export default {
  uuid4 () {
    let result = []

    result.push(randomCharacterFrom({ chars, length: 8 }))
    result.push(randomCharacterFrom({ chars, length: 4 }))
    result.push('4' + randomCharacterFrom({ chars, length: 3 }))
    result.push(randomCharacterFrom({ chars: charsForVariant }) + randomCharacterFrom({ chars, length: 3 }))
    result.push(randomCharacterFrom({ chars, length: 12 }))

    return result.join('-')
  }
}
